import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { isUndefined } from 'lodash';
import useEditSession from './useEditSession';
const withEditSession = (Component) => {
    const Hoc = (props) => {
        const rest = useEditSession();
        return (<Component {...rest} {...props} isEditSessionActive={isUndefined(props.isEditSessionActive)
            ? rest.isEditSessionActive
            : props.isEditSessionActive}/>);
    };
    Hoc.displayName = `withEditSession(${Component.displayName || Component.name})`;
    return hoistNonReactStatics(Hoc, Component);
};
export default withEditSession;
